import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-approved',
  standalone: true,
  imports: [],
  templateUrl: './modal-approved.component.html',
  styleUrl: './modal-approved.component.css'
})
export class ModalApprovedComponent {
  onClose!: Subject<any>;

  icon = '';
  colorCode = '';
  textOne = '';
  textTwo = '';
  textThree = '';
  textDescription = '';

  constructor(public modalRef: BsModalRef) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  cancel() {
    this.onClose.next({ Status: false });
    this.modalRef.hide();
  }

  proceed() {
    this.onClose.next({ Status: true });
    this.modalRef.hide();
  }
}
